import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lc-expert-cleanpage',
  templateUrl: './expert-cleanpage.component.html',
  styleUrls: ['./expert-cleanpage.component.scss']
})
export class ExpertCleanPageComponent implements OnInit {

  contentblocks = [
    {
      styles: {
        'background-image': 'url("/assets/images/expertclean/sonicare_expertclean_image3.jpg")', 
        'background-color': '#FFF',
        'padding-top': '170px',
      },
      available_in: ['nl','fr'],
      contentLeft: {
        title: {
          nl: '<h2 style="color: #0073b4"><strong style="color: #0073b4">Nieuw:</strong><br/><span class="thin">Philips Sonicare<br/> ExpertClean<span></h2>',
          fr: '<h2 style="color: #0073b4"><strong style="color: #0073b4">Nouveau:</strong><br/><span class="thin">Philips Sonicare<br/> ExpertClean<span></h2>'
        },        
        sphere: {
          nl: '<div style="margin-bottom: 5px; margin-top: 5px; font-size: 80%;">Probeer nu 2 stuks voor </div><div style="font-weight: 100; font-size: 80%;">99,- ex btw<div>',
          fr: '<div style="margin-bottom: 5px; margin-top: 5px;">offre 2 pieces a </div><div style="font-weight: 100">99,- hors TVA<div>'
        },
      },
      contentRight: {
        title: {
          nl: '',
          fr: '',
        },
        paragraph: {
          nl: '',
          fr: '',
        },        
      }
    },
    {
      styles: {
        'background-image': '', 
        'background-color': '#FFF',
        'padding-top': '50px'
      },
      available_in: ['nl','fr'],
      contentLeft: {
        title: {
          nl: '',
          fr: '',
        },
        paragraph: {
          nl: '',
          fr: '',
        },
        images: [
          {
            url: 'assets/images/expertclean/sonicare_expertclean_image2.jpg',
            styles: {
              'max-height': '500px'
            }
          }
        ]
      },
      contentRight: {
        title: {
          nl: '<h3><strong>Verbeter</strong> <span class="thin">de poetsroutine<br/>tussen de controles<span><br/></h3>',
          fr: '<h3><strong>Améliorer</strong> <span class="thin"><br/>la routine<span><br/></h3>'
        },
        paragraph: {
          nl: '<p>Smart-sensortechnologie: volgt het poetsgedrag en geeft de patient direct feedback via een trilsignaal en via het voortgangsrapport in de Philips Sonicare app: -Poetsdruksensor"</p><br/><p>BrushSync: Opzetborstel-herkenning, kiest automisch de juiste poetsstand en duur</p><br/><p>Vervangsignaal: geeft op basis van poetstijd, -frequentie en -druk aan wanneer de opzetborstel aan vervanging toe is"</p><br/><p>3 intensiteiten en 3 poetsstanden (Clean, DeepClean en Clean, Gum Health, DeepClean+)</p><br/><p>Smartimer: laat de patiënt minimaal 2 minuten poetsen (tot wel 3 minuten in de DeepClean+ poetsstand.</p>',
          fr: '<p>Technologie de capteur intelligent: suit le comportement du brossage et informe directement le patient via un signal vibrant et via le rapport de progression de l\'application Philips Sonicare</p><br/><p>BrushSync: reconnaissance de la tête de brosse, sélectionne automatiquement la position et la durée de brossage correctes</p><br/><p>Signal de remplacement: donne basé du temps de nettoyage, de la fréquence et de la pression quand la tête de brosse est allumée le remplacement est" 3 intensités et 3 modes de brossage (Clean, Gum Health,DeepClean +)</p><br/><p>Smart timer: laissez le patient brosser pendant au moins 2 minutes(jusqu\'à 3 minutes en mode DeepClean +).</p>'
        },
        buttons: [
          {
            type: 'internal',
            url: '/shop/detail/',
            detail: 'HX9641/01',
            text: {
              nl: 'Bestel nu 2 voor 99,-',
              fr: 'offre pour les dentistes 99,- / 2 pieces'
            },
            color: 'blue'
          }
        ]
      }
    }
  ];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/expert-cleanpage/expert-cleanpage.component.ts